<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>Salary base on table</h1>
      <v-row>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Years of Service"
            :class="classPadding"
            v-model="salaryTable.year"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Amount Increase"
            :class="classPadding"
            v-model="salaryTable.amountIncrease"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            color="success"
            :loading="isSaving"
            :class="classPadding"
            @click.stop="save"
            v-if="userAccess.add >= 1"
            >Save</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>
      <!-- <router-view /> -->
    </v-container>
    <v-dialog v-model="editDialog" width="700" persistent>
      <v-card>
        <v-card-title>
          <span>Edit</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
              <v-text-field
                label="Year From"
                :class="classPadding"
                v-model="editSalaryTable.yearFrom"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
              <v-text-field
                label="Year To"
                :class="classPadding"
                :value="editSalaryTable.yearTo"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
              <v-text-field
                label="Amount Increase"
                :class="classPadding"
                v-model="editSalaryTable.amountIncrease"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.stop="editDialog = false">close</v-btn>
          <v-btn
            text
            @click.stop="update"
            color="success"
            :loading="isUpdating"
            v-if="userAccess.update >= 1"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import List from "./List";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/salaryTable";
export default {
  metaInfo: {
    title: "Salary base on table",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    List
  },
  data: () => ({
    classPadding: "my-0 py-0",
    componentKey: 0,
    salaryTable: {},
    isSaving: false,
    editSalaryTable: {},
    editDialog: false,
    isUpdating: false,
    payLocDialog: false,
    payLocHeaders: [
      {
        text: "",
        align: "left",
        sortable: false,
        value: "action"
      },
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId"
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName"
      }
    ]
  }),
  methods: {
    save() {
      this.$axios
        .post(`${API_ENDPOINT}`, this.salaryTable)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    update() {
      this.isUpdating = true;
      this.editSalaryTable.year = this.editSalaryTable.yearFrom;
      this.$axios
        .put(`${API_ENDPOINT}`, this.editSalaryTable)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    reset() {
      this.salaryTable = {};
      this.forceRerender();
      this.editDialog = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    edit(item) {
      this.editSalaryTable = Object.assign({}, item);
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.id}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    }
  },
  created() {
    this.getUserAccessRights("CBASETUP");
  }
};
</script>